module.exports = __webpack_public_path__ + "img/ipasmntround.7d7a7482.svg";